export const nav = (isNavtoggled) => {
  const $body = $("body");
  const nav = ".js-nav";
  const $nav = $(".js-nav");
  const btnToggleNav = ".js-toggle-nav";

  let navState = isNavtoggled;

  const init = () => {
    bind();
  };

  const observer = new IntersectionObserver(
    ([e]) => e.target.toggleAttribute("stuck", e.intersectionRatio < 1),
    { threshold: [1] }
  );

  const bind = () => {
    $body.on("click", btnToggleNav, e => {
      e.preventDefault();
      toggle();
    });

    // $body.on("click", nav, e => {
    //   e.preventDefault();
    //   toggle();
    // });

    $(".js-nav li a").on('mouseenter', function(event) {
      $('.js-nav li a').addClass("is-faded");
      $(this).removeClass("is-faded");
    });
    $(".js-nav li a").on('mouseleave', function(event) {
      $('.js-nav li a').removeClass("is-faded");
    }); 

    observer.observe(document.querySelector(".js-nav"));

  };

  const toggle = () => {
    if (navState) {
      $body.attr("data-menu-open", "false");
    } else {
      $body.attr("data-menu-open", "true");
    }

    navState = !navState;
  };

  init();
};
